import BFF from '@/services/BFF';

const getInitialProps = async (ctx) => ({
  ...(await BFF.getAppSettings(ctx)()),
});

export default getInitialProps;
